import { styled } from "@mui/material/styles";

export const StyledErrorHandler = styled("div")(({ theme }) => ({
  color: theme.palette.error.main,
}));
